import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/AuthContext';
import './admin/theme.css';
import App from './App';
import LoginPage from './admin/LoginPage';
import Dashboard from './admin/Dashboard';
import JobProgress from './admin/JobProgress';
import UserManagement from './admin/UserManagement';
import Reports from './admin/Reports';
import ProtectedRoute from './admin/ProtectedRoute';

/**
 * Top-level routes.
 *   /             -> the public payment page (unchanged)
 *   /admin/login  -> staff sign-in
 *   /admin        -> the call board (any signed-in staff)
 *   /admin/reports-> rep tracker: jobs per rep + time-to-resolve (admin only)
 *   /admin/users  -> create logins & assign roles (admin only)
 */
export default function AppRouter() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/jobs"
            element={
              <ProtectedRoute>
                <JobProgress />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute adminOnly>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute adminOnly>
                <UserManagement />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
